import React, { useState } from "react";
import { Search, Edit, Trash2, ChevronLeft, ChevronRight } from "lucide-react";

export default function SeoFriendlyNamesPage() {
  const [filter, setFilter] = useState({ name: "", language: "All", active: "All" });
  const [data] = useState([
    { id: 91, name: "100 physical gift card", entityId: 44, entityName: "Product", active: true, language: "Standard" },
    { id: 90, name: "50 physical gift card", entityId: 43, entityName: "Product", active: true, language: "Standard" },
    { id: 7, name: "about login registration", entityId: 7, entityName: "Topic", active: true, language: "Standard" },
    { id: 97, name: "about routekart", entityId: 1, entityName: "NewsItem", active: true, language: "English" },
    { id: 1, name: "about us", entityId: 1, entityName: "Topic", active: true, language: "Standard" },
  ]);

  const handleSearch = (e) => {
    e.preventDefault();
    alert("Search applied!");
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      <h1 className="text-xl font-semibold mb-2 text-gray-800">
        Search engine friendly page names
      </h1>

      {/* Search Section */}
      <div className="bg-white border rounded-lg shadow-sm mb-6">
        <div className="border-b p-3 flex items-center gap-2">
          <Search size={18} />
          <span className="font-medium text-gray-700">Search</span>
        </div>

        <form
          onSubmit={handleSearch}
          className="grid md:grid-cols-3 sm:grid-cols-2 gap-4 p-4"
        >
          <div>
            <label className="block text-sm text-gray-600 mb-1">Name</label>
            <input
              type="text"
              className="w-full border rounded-md p-2 text-sm"
              placeholder="Enter name"
              value={filter.name}
              onChange={(e) => setFilter({ ...filter, name: e.target.value })}
            />
          </div>
          <div>
            <label className="block text-sm text-gray-600 mb-1">Language</label>
            <select
              className="w-full border rounded-md p-2 text-sm"
              value={filter.language}
              onChange={(e) => setFilter({ ...filter, language: e.target.value })}
            >
              <option>All</option>
              <option>Standard</option>
              <option>English</option>
            </select>
          </div>
          <div>
            <label className="block text-sm text-gray-600 mb-1">Is active</label>
            <select
              className="w-full border rounded-md p-2 text-sm"
              value={filter.active}
              onChange={(e) => setFilter({ ...filter, active: e.target.value })}
            >
              <option>All</option>
              <option>Active</option>
              <option>Inactive</option>
            </select>
          </div>

          <div className="md:col-span-3 flex justify-end">
            <button
              type="submit"
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md text-sm"
            >
              Search
            </button>
          </div>
        </form>
      </div>

      {/* Learn more */}
      <p className="text-sm text-gray-600 mb-3">
        Learn more about{" "}
        <span className="text-blue-600 underline cursor-pointer">
          search engine optimization
        </span>
      </p>

      {/* Table */}
      <div className="bg-white border rounded-lg shadow-sm overflow-x-auto">
        <div className="p-2 flex justify-end">
          <button className="bg-red-500 hover:bg-red-600 text-white px-4 py-1.5 rounded-md text-sm flex items-center gap-1">
            <Trash2 size={16} /> Delete selected
          </button>
        </div>

        <table className="min-w-full text-sm border-t">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="p-2 border">
                <input type="checkbox" className="accent-blue-600" />
              </th>
              <th className="p-2 border">ID</th>
              <th className="p-2 border text-left">Name</th>
              <th className="p-2 border">Entity ID</th>
              <th className="p-2 border">Entity name</th>
              <th className="p-2 border">Is active</th>
              <th className="p-2 border">Language</th>
              <th className="p-2 border">Edit page</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr key={item.id} className="hover:bg-gray-50">
                <td className="p-2 border text-center">
                  <input type="checkbox" className="accent-blue-600" />
                </td>
                <td className="p-2 border text-center">{item.id}</td>
                <td className="p-2 border">{item.name}</td>
                <td className="p-2 border text-center">{item.entityId}</td>
                <td className="p-2 border text-center">{item.entityName}</td>
                <td className="p-2 border text-center">
                  {item.active ? (
                    <span className="text-blue-600 font-bold">✓</span>
                  ) : (
                    "—"
                  )}
                </td>
                <td className="p-2 border text-center">{item.language}</td>
                <td className="p-2 border text-center">
                  <button className="bg-gray-100 hover:bg-gray-200 px-3 py-1 rounded-md flex items-center gap-1 mx-auto">
                    <Edit size={14} /> Edit page
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Pagination */}
        <div className="flex flex-col md:flex-row justify-between items-center p-3 gap-2 text-sm">
          <div className="flex items-center gap-2">
            <button className="p-1 border rounded-md hover:bg-gray-100">
              <ChevronLeft size={16} />
            </button>
            <span>1</span>
            <button className="p-1 border rounded-md hover:bg-gray-100">
              <ChevronRight size={16} />
            </button>
            <span className="text-gray-500">of 7</span>
          </div>

          <div className="flex items-center gap-2">
            <span>Show</span>
            <select className="border rounded-md p-1 text-sm">
              <option>15</option>
              <option>25</option>
              <option>50</option>
            </select>
            <span>items</span>
          </div>

          <span className="text-gray-500">1-5 of 101 items</span>
        </div>
      </div>
    </div>
  );
}
